/** Cursor-style back/forward stack for Fleet session key (agent/kind/id) navigation. */
export type SessionNavigatorHistory = {
  past: string[];
  current: string;
  future: string[];
};

export function createSessionNavigatorHistory(current: string): SessionNavigatorHistory {
  const trimmed = current.trim();
  return { past: [], current: trimmed, future: [] };
}

export function canSessionNavigatorBack(history: SessionNavigatorHistory): boolean {
  return history.past.length > 0;
}

export function canSessionNavigatorForward(history: SessionNavigatorHistory): boolean {
  return history.future.length > 0;
}

/** Record a user-driven navigation to `next` (clears forward stack). */
export function pushSessionNavigatorHistory(
  history: SessionNavigatorHistory,
  next: string,
): SessionNavigatorHistory {
  const trimmed = next.trim();
  if (!trimmed || trimmed === history.current) {
    return history;
  }
  return {
    past: [...history.past, history.current],
    current: trimmed,
    future: [],
  };
}

export function navigateSessionNavigatorBack(
  history: SessionNavigatorHistory,
): { history: SessionNavigatorHistory; sessionKey: string } | null {
  if (history.past.length === 0) {
    return null;
  }
  const previous = history.past[history.past.length - 1]!;
  return {
    history: {
      past: history.past.slice(0, -1),
      current: previous,
      future: [history.current, ...history.future],
    },
    sessionKey: previous,
  };
}

export function navigateSessionNavigatorForward(
  history: SessionNavigatorHistory,
): { history: SessionNavigatorHistory; sessionKey: string } | null {
  if (history.future.length === 0) {
    return null;
  }
  const next = history.future[0]!;
  return {
    history: {
      past: [...history.past, history.current],
      current: next,
      future: history.future.slice(1),
    },
    sessionKey: next,
  };
}
